import React from 'react';

import UserSettingsBlockMobile from '../blocks/UserSettingsBlockMobile';
import ChangePasswordBlockMobile from '../blocks/ChangePasswordBlockMobile';

const ProfileTabContentMobile = () => {
  return (
    <div>
      <UserSettingsBlockMobile />
      <ChangePasswordBlockMobile />
    </div>
  );
};

export default ProfileTabContentMobile;
